"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ReportsModel = /** @class */ (function () {
    function ReportsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + '/api/v1/reports',
            UPDATE: APPURL + '/api/v1/reports',
            CREATE: APPURL + '/api/v1/reports'
        },
            this.report = [];
        this.extract = this.extract.bind(this);
        this.cacheResponse = this.cacheResponse.bind(this);
    }
    ReportsModel.prototype.extract = function (result) {
        return result.data;
    };
    ReportsModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    ReportsModel.prototype.getAdminStudentIndexStats = function (data) {
        if (data) {
            return this.$http.get(this.URLS.FETCH + '/adminStudentIndex?' + (0, queryString_1.toQueryString)(data)).then(this.cacheResponse);
        }
        return this.$http.get(this.URLS.FETCH + '/adminStudentIndex').then(this.cacheResponse);
    };
    ;
    ReportsModel.prototype.getAdminDashboard = function () {
        return this.$http.get(this.URLS.FETCH + '/admin/dashboard').then(this.cacheResponse);
    };
    ;
    ReportsModel.prototype.getPickupLocations = function () {
        return this.$http.get(this.URLS.FETCH + '/pickuplocations').then(this.cacheResponse);
    };
    return ReportsModel;
}());
ReportsModel.$inject = ['$http', 'APPURL'];
exports.default = ReportsModel;
